import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import classNames from 'classnames'
import { SingleEssential } from '../../redux-toolkits/lists/list.types'
import Icon from '../icon'

export const HPEssential = ({
  essential,
  id,
  sortable = false,
  className = '',
  onRemove,
}: {
  essential: SingleEssential
  id: string
  sortable?: boolean
  className?: string
  onRemove?: () => void
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div
      className={classNames(
        'relative w-full flex flex-col bg-frost',
        className,
      )}
      ref={setNodeRef}
      style={style}
    >
      <img
        src={essential.icon}
        className="block w-full aspect-square object-cover rounded-md"
        alt={`icon`}
      />

      <p className="line-clamp-1 mt-4 text-black text-base font-medium">
        {essential.title}
      </p>

      <p className="line-clamp-1 mt-1 text-sec-black text-sm">
        {essential.summary}
      </p>

      {id && sortable ? (
        <div className="flex w-full items-end justify-center flex-1">
          <button
            className="w-fit cursor-grab mx-auto mt-4 !max-w-[50px]"
            {...attributes}
            {...listeners}
            type="button"
          >
            <Icon id="rearrange" width={24} height={24} />
          </button>
        </div>
      ) : undefined}

      {onRemove && (
        <button
          className={classNames(
            'p-2 bg-gray-bg rounded-full w-fit absolute top-4 right-4',
          )}
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            onRemove()
          }}
        >
          <Icon className="text-danger" width={20} height={20} id="bin" />
        </button>
      )}
    </div>
  )
}
